import Stack from '@mui/material/Stack';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog, Floating } from 'components';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import taskForwarding from 'features/views/taskForwarding';
import formDescriptorFn, { TASK_FORWARDING_FORM_NAME } from 'features/views/taskForwarding/form';

import ActionButtons from './components/ActionButtons';
import RedirectForm from './components/Form';
import TasksTable from './components/TasksTable';

const TaskForwarding = () => (
	<Form name={TASK_FORWARDING_FORM_NAME} formDescriptorFn={formDescriptorFn}>
		<Stack spacing={1}>
			<SubmitFormDialog pageName={TASK_FORWARDING_FORM_NAME} />
			<Floating modal>
				<Dialog name={taskForwarding.constants.dialogs.validation_error} mui>
					{getLabelMessage('common:validation_error')}
				</Dialog>
				<Dialog name={taskForwarding.constants.dialogs.taskAmountToForwardLimit} mui>
					{getLabelMessage('processInformation:userCanProcessMax10Tasks')}
				</Dialog>
			</Floating>
		</Stack>
		<Stack spacing={2}>
			<TasksTable />
			<RedirectForm />
			<ActionButtons />
		</Stack>
	</Form>
);

export default TaskForwarding;
